import { render, staticRenderFns } from "./CasualsAuth.vue?vue&type=template&id=506365af&scoped=true&"
import script from "./CasualsAuth.vue?vue&type=script&lang=js&"
export * from "./CasualsAuth.vue?vue&type=script&lang=js&"
import style0 from "./CasualsAuth.vue?vue&type=style&index=0&id=506365af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506365af",
  null
  
)

export default component.exports